import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Paper, } from '@mui/material';
import { useStore, } from '@mcn-platform/models';
import ItemContent from './ItemContent';
import InfoTabs from './InfoTabs';
import ActionButtons from './ActionButtons';
import Notes from '../notes/Notes';
import formatSeconds from '../../common/formatSeconds';
const LessonPanel = ({ course, courseSection, courseProgress, seekPosition, seekTrigger, currentPosition, maxPosition, setCurrentPosition, handleNextPrevious, updateProgress, onQuizAttemptComplete, isMobileView, settings: { showMakeANoteBtn, showPlayerControls, showActionBtns, 
// showAddToListBtn,
// showShareBtn,
showReportIssueBtn, showCTABtn, showInfoTabs, handleViewNote, showTranscriptTab, showOverviewTab, showMaterialTab, showQnATab, }, }) => {
    const [lessonDuration, setLessonDuration] = useState(0);
    const [lastPercentUpdate, setLastPercentUpdate] = useState(0);
    // The interval in seconds on which the course item should be updated
    const updateProgressInterval = 10;
    let ctaLabel = null;
    let ctaUrl = null;
    let openCTANewWindow = false;
    const { isAnonymous } = useStore();
    if (courseSection.item?.ctaLabel && courseSection.item?.ctaUrl) {
        ctaLabel = courseSection.item.ctaLabel;
        ctaUrl = courseSection.item.ctaUrl;
        openCTANewWindow = courseSection.item.ctaNewWindow;
    }
    else {
        ctaLabel = course.ctaLabel;
        ctaUrl = course.ctaUrl;
        openCTANewWindow = course.ctaNewWindow;
    }
    const OnMediaProgress = (newPosition, newMaxPosition) => {
        if (courseSection.type === 'video' || courseSection.type === 'audio' || courseSection.type === 'microcast' || !!course.microcastImage) {
            const percent = Math.ceil((currentPosition / lessonDuration) * 100);
            if (newPosition > 0 && Math.floor(newPosition) % updateProgressInterval === 0) {
                updateProgress(courseSection, percent, newPosition, newMaxPosition);
            }
            else if ((percent >= 99 || (lessonDuration - newPosition) < 5)
                && percent !== lastPercentUpdate) {
                // flip it to done if over 99% or less than 5 seconds remaining
                // console.log('section complete', { progress, lessonDuration, percent });
                updateProgress(courseSection, 100, newPosition, newMaxPosition);
                setLastPercentUpdate(percent);
            }
        }
        if (setCurrentPosition) {
            setCurrentPosition(Math.floor(newPosition));
        }
    };
    const OnComplete = () => {
        console.log('OnComplete called');
        // if its already complete then don't update
        const sectionProgress = courseProgress?.lessonProgress?.[courseSection.id];
        if (!sectionProgress?.isCompleted) {
            updateProgress(courseSection, 100);
        }
        if (course.enableAutoplay) {
            handleNextPrevious('next');
            // keep playing the next video
            return true;
        }
        // reset playing to false
        return false;
    };
    const makeReference = () => ([
        `${course.id}/${courseSection?.id}/video/${currentPosition}`,
        `${course.name}/${courseSection?.name}/Video/${formatSeconds(currentPosition)}`,
    ]);
    return (_jsxs(Paper, { sx: { boxShadow: 0, backgroundColor: 'transparent', paddingBottom: 4 }, children: [_jsx(Box, { sx: {
                    width: '100%',
                    minHeight: '100%',
                    borderRadius: 1,
                    my: { xs: 0, md: 2 },
                }, children: _jsx(ItemContent, { owner: course, section: courseSection, isMicrocast: !!course.microcastImage, progress: courseProgress, showPlayerControls: showPlayerControls, seekPosition: seekPosition, maxPosition: maxPosition, seekTrigger: seekTrigger, onProgress: OnMediaProgress, onEnd: OnComplete, onAttemptComplete: () => onQuizAttemptComplete(courseSection), onDuration: setLessonDuration, actionButtons: showActionBtns && (_jsx(ActionButtons, { showMakeANoteBtn: isAnonymous ? false : showMakeANoteBtn, showAddToListBtn: false, showShareBtn: false, showReportIssueBtn: showReportIssueBtn, showCTABtn: showCTABtn, ctaLabel: ctaLabel, ctaUrl: ctaUrl, openCTANewWindow: openCTANewWindow })), handleNextPrevious: handleNextPrevious }) }), !isAnonymous && isMobileView && showMakeANoteBtn && (_jsx(Box, { sx: { mb: 3 }, children: _jsx(Notes, { handleViewNote: handleViewNote, makeReference: makeReference, isCourseItemSelected: !!courseSection?.id, progress: courseProgress, modelName: "courseProgress" }) })), showInfoTabs && (courseSection.type !== 'quiz') && (_jsx(Box, { children: _jsx(InfoTabs, { item: course, section: courseSection, settings: {
                        showTranscriptTab,
                        defaultInfoTab: 0,
                        showOverviewTab,
                        showMaterialTab,
                        showQnATab,
                    } }) }))] }));
};
LessonPanel.defaultProps = {
    isMobileView: false,
    seekPosition: undefined,
    seekTrigger: undefined,
    settings: {
        showPlayerControls: true,
        showActionBtns: true,
        showMakeANoteBtn: true,
        // showAddToListBtn: true,
        // showShareBtn: true,
        showReportIssueBtn: false,
        showCTABtn: true,
        showInfoTabs: true,
        showTranscriptTab: true,
        showOverviewTab: true,
        showMaterialTab: true,
        showQnATab: true,
    },
};
LessonPanel.meta = {
    group: 'hidden',
    name: 'Course Lesson Panel',
    description: 'Component displays the course lesson details and player.',
    props: [
        {
            key: 'course',
            name: 'Course',
            type: 'course', // note this is a special type recognized by the system
            description: 'The course to display information about',
        },
        {
            key: 'settings.showPlayerControls',
            name: 'Show Player Controls',
            type: 'boolean',
            description: 'Show all video player controls.',
        },
        {
            key: 'settings.showActionBtns',
            name: 'Show lesson action Buttons',
            type: 'boolean',
            description: 'Show lesson action Buttons below player.',
        },
        {
            key: 'settings.showMakeANoteBtn',
            name: 'Show make a note button',
            type: 'boolean',
            description: 'Show make a note button below player.',
        },
        // {
        //   key: 'settings.showAddToListBtn',
        //   name: 'Show add to list button',
        //   type: 'boolean',
        //   description: 'Show add to list button below player.',
        // },
        // {
        //   key: 'settings.showShareBtn',
        //   name: 'Show share lesson button',
        //   type: 'boolean',
        //   description: 'Show share lesson button below player.',
        // },
        {
            key: 'settings.showReportIssueBtn',
            name: 'Show report issue button',
            type: 'boolean',
            description: 'Show report issue button below player.',
        },
        {
            key: 'settings.showCTABtn',
            name: 'Show CTA btn',
            type: 'boolean',
            description: 'Show call to action (CTA) button below player.',
        },
        {
            key: 'settings.showInfoTabs',
            name: 'Show video tabs',
            type: 'boolean',
            description: 'Show video detail tabs like overview, material and transcript.',
        },
        {
            key: 'settings.showQnATab',
            name: 'Show Q&A Tab',
            type: 'boolean',
            description: 'Show the Q&A tab for the lesson.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'LessonPanel',
        props: {
            courseName: '@course.name',
            courseItem: '@course.sections[1].sections[0].sections[0]',
            settings: {
                showPlayerControls: true,
                showActionBtns: true,
                showMakeANoteBtn: true,
                showAddToListBtn: true,
                showShareBtn: true,
                showReportIssueBtn: true,
                showCTABtn: true,
                showInfoTabs: true,
                showQnATab: true,
            },
        },
    },
};
export default observer(LessonPanel);
//# sourceMappingURL=LessonPanel.js.map